export const state = {
  jafDomains: [
    'jafnavi.jp',
    'www.jaf.or.jp',
    'area.jaf.or.jp',
  ],
}
